module.exports = __webpack_public_path__ + "media/images/Podcaster-5cc33fa231402fc75d3053d8f78be7f8.svg";